import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminFranchiseLeads from "@/pages/admin/AdminFranchiseLeads";

export const Route = createFileRoute("/admin/franchise-leads")({
  head: () => pageHead("Admin \u2014 Franchise Leads \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminFranchiseLeads,
});
